
/*
    This relys on checkboxes and labels to work correctly.
    The script below is the glue that ties eveything together.

    By default the first item of each Engine and Spec are visible.
    By using the checkboxes via labels we can tiggle the Spec list for each engine.
    However we need to use javascript to toggle the avaliable Specs ( via knots )

    In turn when we change knots we cycle though the performance specs for
    the respective engine.

    This would be probably better suited to use a state managment library.
    but this was faster for now.

    It's very dependant on DOM so be careful what you move.

*/
export default () => {

    const engines = document.querySelectorAll('[name="engine"]')
    const controls = document.querySelectorAll('.performance-knots-control')

    engines.forEach(engine => {

        const ID = engine.getAttribute('id').split('-')[1]
        const dependants = document.querySelectorAll(`[data-engine]`)
        const specifics = document.querySelectorAll(`[data-engine="${ID}"]`)

        engine.addEventListener('change', e => {
            dependants.forEach(el => el.classList.remove('active'))
            specifics.forEach(el => el.classList.add('active'))
        })
    })

    controls.forEach(control => {

        const parent = control.parentElement
        const specs = document.querySelectorAll(`[data-engine="${parent.dataset.engine}"] [data-spec]`)

        const triggerPrev = parent.querySelector('.previous')
        const triggerNext = parent.querySelector('.next')

        const points = parent.querySelectorAll('.performance-knots-datapoint')

        function n(fn) {
            const active = parent.querySelector('.active')
            const nextSpec = fn(active).dataset.spec
            const next = document.querySelectorAll(`[data-spec="${nextSpec}"]`)

            specs.forEach(el => el.classList.remove('active'))
            next.forEach(el => el.classList.add('active'))
        }

        triggerNext.addEventListener('click', () => {
            n(active => active.nextElementSibling || points[0])
        })

        triggerPrev.addEventListener('click', () => {
            n(active => active.previousElementSibling || points[points.length - 1])
        })
    })
}
